import React from 'react';
import FlowNodeIcon from '../../FlowNodeIcon';
import { useProjectState } from '@starflow/app/store';
import { isGtLen } from '../../../utils';
import { Tooltip } from '@mantine/core';
import { getProcessor } from '@starflow/app/helpers/flow';
import cs from 'classnames';

const UnitLists = React.memo(({ data }) => {
  const currentNodeId = useProjectState('currentNodeId');
  const handleClick = (data) => {
    const processor = getProcessor(data.type);

    if (processor?.onNodeClick) {
      processor.onNodeClick(data);
    }
  };
  return (
    <div className="flex flex-col overflow-auto p-3 mb-10">
      <span className="text-[#7A7A7A] overflow-ellipsis overflow-hidden whitespace-nowrap">独立工作单元</span>
      {data.map((item) => {
        const label = item.data.label;
        return (
          <div className="flex h-[30px] items-center cursor-pointer" onClick={() => handleClick(item.data)}>
            <FlowNodeIcon type="unit" isSelected={currentNodeId === item.id} />
            {isGtLen(label) ? (
              <Tooltip withArrow position="top" offset={10} className="scale-90" label={label}>
                <div
                  className={cs(
                    'overflow-ellipsis overflow-hidden whitespace-nowrap w-[100px] text-left h-[18px] ml-[10px]',
                    currentNodeId === item.id ? 'text-[#009DFF]' : 'text-[#2D2D2D]',
                  )}
                >
                  {label}
                </div>
              </Tooltip>
            ) : (
              <span
                className={cs(
                  'h-[18px] block ml-[10px]',
                  currentNodeId === item.id ? 'text-[#009DFF]' : 'text-[#2D2D2D]',
                )}
              >
                {label}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
});

export default UnitLists;
